import { createReducer, on } from "@ngrx/store";

export const questionFeatureKey = "question";

export interface QuestionState {

}

export const initialState: QuestionState = {

};

export const questionReducer = createReducer(
	initialState,

);
